'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _groupBy2 = require('lodash/groupBy');

var _groupBy3 = _interopRequireDefault(_groupBy2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _ButtonToolbar = require('react-bootstrap/lib/ButtonToolbar');

var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);

var _Modal = require('react-bootstrap/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _common = require('../../common');

var _commonFormsy = require('../../common-formsy');

var _constants = require('../../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var APPLICATION_TRANSITION_REASON_SHORT_CODES = _constants.AppConstants.APPLICATION_TRANSITION_REASON_SHORT_CODES;
var ApplicationRejectionModal = (_dec = (0, _mobxReact.inject)('OptionsStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(ApplicationRejectionModal, _Component);

  function ApplicationRejectionModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ApplicationRejectionModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ApplicationRejectionModal.__proto__ || Object.getPrototypeOf(ApplicationRejectionModal)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'selectedValue', _descriptor, _this), _initDefineProp(_this, 'notes', _descriptor2, _this), _initDefineProp(_this, 'isValid', _descriptor3, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ApplicationRejectionModal, [{
    key: 'handleRadioClick',
    value: function handleRadioClick(value) {
      this.selectedValue = Number.parseInt(value);
    }
  }, {
    key: 'handleEditedNotes',
    value: function handleEditedNotes(e) {
      this.notes = e;
    }
  }, {
    key: 'validationRequiredForOtherSelection',
    value: function validationRequiredForOtherSelection(values, value) {
      var OTHER = this.props.OptionsStore.getApplicationTranistionReasonByShortCode(APPLICATION_TRANSITION_REASON_SHORT_CODES.OTHER);
      return !!(values.reason === OTHER.id && value || values.reason !== OTHER.id);
    }
  }, {
    key: 'onValidChange',
    value: function onValidChange(isValid) {
      this.isValid = isValid;
    }
  }, {
    key: 'renderForm',
    value: function renderForm() {
      var _this2 = this;

      var OptionsStore = this.props.OptionsStore,
          rejectedReasons = OptionsStore.getApplicationTranisitionReasonsByStatus('rejected'),
          rejectedReasonsByType = (0, _groupBy3.default)(rejectedReasons, function (option) {
        return option.reason.type;
      }),
          types = Object.keys(rejectedReasonsByType);


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'two-columns' },
          types.map(function (type) {
            return _react2.default.createElement(
              'div',
              { key: type, className: 'column' },
              _react2.default.createElement(_common.RadioButtonGroup, {
                checker: _this2.selectedValue || 1,
                descriptionLookupString: 'reason.description',
                fieldName: 'rejection_reason',
                handleRadioClick: _this2.handleRadioClick,
                items: rejectedReasonsByType[type],
                lookupString: 'id',
                title: type
              })
            );
          })
        ),
        _react2.default.createElement(_commonFormsy.Input, {
          type: 'hidden',
          name: 'reason',
          value: this.selectedValue,
          validations: 'isExisty',
          validationErrors: 'A reason is required to reject this application',
          required: true
        }),
        _react2.default.createElement(_commonFormsy.Textarea, {
          className: 'rejection-notes',
          label: 'Notes',
          name: 'notes',
          onChange: this.handleEditedNotes,
          showError: true,
          validationErrors: { requiredForOtherSelection: 'Please add a note when selecting other as a reason' },
          validations: { requiredForOtherSelection: this.validationRequiredForOtherSelection },
          value: this.notes
        })
      );
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(model) {
      var UiStore = this.props.UiStore;

      UiStore.rejectApplicationOnSave(model);
      UiStore.modals.RejectApplication.close();
    }
  }, {
    key: 'setRefForm',
    value: function setRefForm(comp) {
      this.refForm = comp;
    }
  }, {
    key: 'render',
    value: function render() {
      var UiStore = this.props.UiStore,
          close = UiStore.modals.RejectApplication.close;


      return _react2.default.createElement(
        _Modal2.default,
        { show: true, onHide: close },
        _react2.default.createElement(
          _commonFormsy.Form,
          {
            onValidSubmit: this.handleSubmit,
            ref: this.setRefForm,
            onValidChange: this.onValidChange
          },
          _react2.default.createElement(
            _Modal2.default.Header,
            { closeButton: true },
            _react2.default.createElement(
              _Modal2.default.Title,
              null,
              'What\'s the reason for rejecting this application?'
            )
          ),
          _react2.default.createElement(
            _Modal2.default.Body,
            null,
            this.renderForm()
          ),
          _react2.default.createElement(
            _Modal2.default.Footer,
            null,
            _react2.default.createElement(
              _ButtonToolbar2.default,
              { className: 'pull-right' },
              _react2.default.createElement(
                _Button2.default,
                { onClick: close },
                'Cancel'
              ),
              _react2.default.createElement(
                _Button2.default,
                { disabled: !this.isValid, bsStyle: 'primary', type: 'submit' },
                'Save'
              )
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ApplicationRejectionModal;
}(_react.Component), _class3.propTypes = {
  OptionsStore: _propTypes2.default.object.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'selectedValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'notes', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'isValid', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'handleRadioClick', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handleRadioClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleEditedNotes', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handleEditedNotes'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = ApplicationRejectionModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(APPLICATION_TRANSITION_REASON_SHORT_CODES, 'APPLICATION_TRANSITION_REASON_SHORT_CODES', '/app/src/components/page-case/main-applications/ApplicationRejectionModal.js');
  reactHotLoader.register(ApplicationRejectionModal, 'ApplicationRejectionModal', '/app/src/components/page-case/main-applications/ApplicationRejectionModal.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-applications/ApplicationRejectionModal.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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